import {IServiceFactory} from "../../../service-factory.interface";
import {
    StandardDropDownListItemModel
} from "../../../../components/forms/standard-drop-down/list-view/models/item/standard-drop-down-list-item.model";
import {IPassengerPsoCategoryViewModel} from "./passenger-pso-category.view-model.interface";

export class AdultPassengerPsoCategory extends StandardDropDownListItemModel<number> implements IPassengerPsoCategoryViewModel{
    constructor(readonly id: number, private readonly _getDescription: () => string) {
        super(id, _getDescription());
    }

    get description(): string {
        return this._getDescription();
    }

    getDisplayText(): string {
        return this.description;
    }

    public static getCategoriesByIds(services: IServiceFactory, ...ids: number[]): AdultPassengerPsoCategory[] {
        return AdultPassengerPsoCategory.getCategories(services).filter(c => ids.includes(c.id));
    }

    generateSqlScript(): string {
        return `INSERT INTO dbo.PsoPassengerCategory (id, name) VALUES (${this.id}, '${this.description}')`;
    }

    public static getCategories(services: IServiceFactory): AdultPassengerPsoCategory[] {
        const language = services.language;
        return [
            new AdultPassengerPsoCategory(1, () =>  language.translate('Resident in Sardinia passenger')),
            new AdultPassengerPsoCategory(2, () =>  language.translate('Disabled passenger')),
            new AdultPassengerPsoCategory(3, () =>  language.translate('Accompanying person of a disable passenger')),
            new AdultPassengerPsoCategory(4, () =>  language.translate('University students up to 27 years old')),
            new AdultPassengerPsoCategory(5, () =>  language.translate('Young passenger from 12 up to 22 years old')),
            new AdultPassengerPsoCategory(6, () =>  language.translate('Senior passenger aged 70 and above')),
            new AdultPassengerPsoCategory(7, () =>  language.translate('Military personnel with documented permanent and continuous work assignment in Sardinia')),
            new AdultPassengerPsoCategory(8, () =>  language.translate('Employee with documented permanent and continuous work assignment in Sardinia')),
            new AdultPassengerPsoCategory(9, () =>  language.translate('Non-professional competitive athlete registered with a sports club based in Sardinia')),

            new AdultPassengerPsoCategory(10, () =>  language.translate('Non-resident passenger travelling to Sardinia for work purposes')),
            new AdultPassengerPsoCategory(11, () =>  language.translate('Non-residents passenger related by first, second, or third degree, or linked by marriage or filiation to beneficiaries of this fare')),
            new AdultPassengerPsoCategory(12, () =>  language.translate('Non-resident passenger benefiting from extraordinary leave or permits pursuant to Law 104/92 to assist a relative resident in Sardinia')),
            new AdultPassengerPsoCategory(13, () =>  language.translate('Non-resident passenger acting as legal guardians of a person resident in Sardinia')),
        ]
    }
}

export class ChildPassengerPsoCategory extends StandardDropDownListItemModel<number> implements IPassengerPsoCategoryViewModel {
    constructor(id: number, private readonly _getDescription: () => string) {
        super(id, _getDescription());
    }

    get description(): string {
        return this._getDescription();
    }

    getDisplayText(): string {
        return this.description;
    }

    generateSqlScript(): string {
        return `INSERT INTO dbo.PsoPassengerCategory (Id, Name) VALUES (${this.id}, '${this.description}')`;
    }

    public static getCategoriesByIds(services: IServiceFactory, ...ids: number[]): ChildPassengerPsoCategory[] {
        return ChildPassengerPsoCategory.getCategories(services).filter(c => ids.includes(c.id));
    }

    public static getCategories(services: IServiceFactory): ChildPassengerPsoCategory[] {
        const language = services.language;
        return [
            new ChildPassengerPsoCategory(100, () =>  language.translate('Child under 2 years old travelling free of charge without occupying a seat')),
            new ChildPassengerPsoCategory(101, () =>  language.translate('Child aged 2 to under 12 resident in Sardinia')),
            new ChildPassengerPsoCategory(102, () =>  language.translate('Child aged 2 to under 12 non-resident in Sardinia')),
            new ChildPassengerPsoCategory(103, () =>  language.translate('Child aged 2 to under 12 relative of a resident in Sardinia')),

        ]
    }
}

export function generatePsoCategoriesSqlScripts(services: IServiceFactory) {
    const categories = [
        ...AdultPassengerPsoCategory.getCategories(services).map(c => c.generateSqlScript()),
        ...ChildPassengerPsoCategory.getCategories(services).map(c => c.generateSqlScript())
    ];
    console.log(categories.join("\n"));
}